import * as React from 'react';
import { observer } from 'mobx-react';

// Styles
const s = require('./NoImagePlaceholder.css');
const noImage = require('./../../assets/image-placeholder.svg');

// Component
@observer
export class NoImagePlaceholder extends React.Component<{}, {}> {
    public render() {
        return (
            <div className={s.noImage}>
                <img src={noImage} />
                <p>No image</p>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./app/web/src/components/item/NoImagePlaceholder.tsx